// extracted by mini-css-extract-plugin
export default {"properties":"Properties_properties__Ft5lW","map":"Properties_map__dtH0W"};